/// <reference path="../../app.ts" />
namespace Cfnc {
    "use strict";

    interface ICustomerSelectorModalScope extends ng.IScope {
        close;
        getData;
        selectSchool;
        hasError: boolean;
        selectedSchool: any;
        searchSchools: (value: any) => void;
        resetSchools: () => void;
        category: string;
        hideCategories: boolean;
        customers: Array<any>;
    }

    interface ICustomerSelectorModal {

    }

    interface ICustomerSelectorModalOptions {
        category: string;
        hideCategories: string;
    }

    class CustomerSelectorModal implements ICustomerSelectorModal {
        static controllerId: string = "customerSelectorModal";
        private log;
        constructor(private $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance,
            private common: ICommonFactory,
            private $scope: ICustomerSelectorModalScope,
            private Restangular: Restangular.IService,
            private options: ICustomerSelectorModalOptions) {

            this.log = common.logger.getLogFn(CustomerSelectorModal.controllerId);
            $scope.category = this.options.category || "PK-12";
            $scope.close = () => this.close();
            $scope.selectSchool = () => this.selectSchool();
            $scope.searchSchools = (value: any) => this.searchSchools(value);
            $scope.hasError = false;
            $scope.resetSchools = () => this.resetSchools();
            $scope.hideCategories = this.options.hideCategories == "true";
            $scope.customers = [];
        }


        close() {
            this.$uibModalInstance.dismiss();
        }

        selectSchool = () => {
            if (this.$scope.selectedSchool != null || this.$scope.selectedSchool.name == "My School or Program is not listed") {
                this.$uibModalInstance.close(this.$scope.selectedSchool);
                this.log("Selected " + this.$scope.selectedSchool);
            }
            else {
                this.$scope.hasError = true;
            }
        };

        searchSchools(value: any) {
            var query = { startsWith: value, type: this.$scope.category };
            return this.Restangular.all("customers/getbytype").getList(query).then((results) => {
                this.$scope.hasError = false;
                this.$scope.customers = results;
                return results;
            }, (reason) => {
                console.error(reason);
            });

        };

        resetSchools = () => {
            this.$scope.customers = [];
        }
    }


    angular.module("app").controller(CustomerSelectorModal.controllerId, ["$uibModalInstance", "common", "$scope", "Restangular", "options",
        ($uibModalInstance: ng.ui.bootstrap.IModalServiceInstance,
            common: ICommonFactory,
            $scope: ICustomerSelectorModalScope,
            Restangular,
            options: ICustomerSelectorModalOptions) =>
            new CustomerSelectorModal($uibModalInstance, common, $scope, Restangular, options)
    ]);

    var data = [];
}
